import { OG_IMAGE } from '@Constants';
import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import Footer from '../../components/Footer/Footer';
import GlobalStyles from '../../components/GlobalStyles';
import Header from '../../components/Header/Header';
import { SectionCrazy } from './components/SectionCrazy';
import { SectionDeliverable } from './components/SectionDeliverable';
import { SectionFAQ } from './components/SectionFAQ';
import { SectionHero } from './components/SectionHero';
import { SectionHeyThere } from './components/SectionHeyThere';
import { SectionIncludes } from './components/SectionIncludes';
import { SectionInstructors } from './components/SectionInstructors';
import { SectionMoment } from './components/SectionMoment';
import { SectionPricing } from './components/SectionPricing';
import { SectionProof } from './components/SectionProof';
import { SectionSecret } from './components/SectionSecret';
import { SectionTestimonials } from './components/SectionTestimonials';
import { SectionThisWay } from './components/SectionThisWay';
import './Home.css';

export default function Home(props) {
  return (
    <Fragment>
      <HelmetConfig />
      <GlobalStyles />

      <Header />

      <SectionHero />
      <SectionIncludes />
      <SectionMoment />
      <SectionProof />
      <SectionCrazy />
      <SectionThisWay />
      <SectionSecret />
      <SectionHeyThere />
      <SectionDeliverable />
      <SectionInstructors />
      <SectionTestimonials />
      <SectionPricing />
      <SectionFAQ />

      <Footer />
    </Fragment>
  );
}

const HelmetConfig = function() {
  const metaTitle = 'The 167 - 12-Week Social Media Mentorship with Brady Shearer';
  const metaDesc =
    'The 167 is a 12-week mentorship program where you’ll learn the 6-step process for using social media to help accomplish your church’s biggest goals.';
  const metaUrl = 'https://www.the167.cc';

  return (
    <Helmet>
      <meta charSet="utf-8" />
      <title>{metaTitle}</title>
      <link rel="canonical" href={metaUrl} />
      <meta name="description" content={metaDesc} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={metaDesc} />
      <meta property="og:url" content={metaUrl} />
      <meta property="og:image" content={OG_IMAGE} />
      <meta property="og:image:type" content="image/jpeg" />
      <meta property="og:image:width" content="2400" />
      <meta property="og:image:height" content="1260" />
      <meta name="twitter:url" content={metaUrl} />
      <meta name="twitter:title" content={metaTitle} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={metaTitle} />
      <meta name="twitter:description" content={metaDesc} />
      <meta name="twitter:image" content={OG_IMAGE} />
    </Helmet>
  );
};



// WEBPACK FOOTER //
// ./src/routes/Home/Home.js